import { ObjectUtil } from 'app/utils/object.util';

export class UserPreferences {
  parkMenu: any;
  headerDropdownColorType: any;

  static mapPreferences(preferences: any) {
    return new UserPreferences({
      parkMenu: ObjectUtil.getProperty(preferences, 'parkMenu'),
      headerDropdownColorType: ObjectUtil.getProperty(preferences, 'headerDropdownColorType')
    });
  }

  constructor(init: Partial<UserPreferences>) {
    Object.assign(this, init);
  }
}
